export const solutionPlans = [
  {
    name: 'Free Member',
    plan: 'Free',
    bgColor: 'bg-[#fffbe3]',
    width: 281,
  },
  {
    name: 'Silver Member',
    plan: 'Silver',
    bgColor: 'bg-[#fbffe5]',
    width: 281,
  },
  {
    name: 'Gold Member',
    plan: 'Gold',
    bgColor: 'bg-[#fffbe3]',
    width: 281,
  },
  {
    name: 'Platinum Member',
    plan: 'Platinum',
    bgColor: 'bg-[#fbffe5]',
    width: 281,
  },
]

export const profilePrintDirectory = [
  {
    text: 'Profile In Print Directory',
  },
  {
    isImageCell: true,
  },
  {
    isImageCell: true,
  },
  {
    text: 'Big Listing With Gm Picto',
  },
  {
    text: 'Big Listing With Pm Picto',
  },
]

export const emptyDataList = ['', '', '', '']

export const profileWebsiteVisibleForList = [
  {
    text: 'Profile / Website, Visible For All Visitors',
  },
  {
    text: '',
  },
  {
    text: '',
  },
  {
    isImageCell: true,
  },
  {
    isImageCell: true,
  },
]

export const priorityInResultPageList = [
  {
    text: 'Priority Listing In The Results Pages',
  },
  {
    text: '',
  },
  {
    text: '',
  },
  {
    isImageCell: true,
  },
  {
    isImageCell: true,
  },
]
export const profileInSelfManagementList = [
  {
    text: 'Profile In Self-Management / My Fructidor',
  },
  {
    isImageCell: true,
  },
  {
    isImageCell: true,
  },
  {
    isImageCell: true,
  },
  {
    isImageCell: true,
  },
]

export const profileVisitorsList = [
  {
    text: 'Profile / Website, Visible For All Visitors',
  },
  {
    isImageCell: true,
  },
  {
    isImageCell: true,
  },
  {
    isImageCell: true,
  },
  {
    isImageCell: true,
  },
]

export const printDirectoryList = [
  {
    text: '',
  },
  {
    text: '1 Pack',
  },
  {
    text: '2 Packs',
  },
  {
    text: '3 Packs',
  },
]

export const onlineAccessList = [
  {
    text: 'Access Only To Gm Pm Accounts',
  },
  {
    text: 'Acc To All Accounts',
  },
  {
    text: 'Acc To All Accounts',
  },
  {
    text: 'Acc To All Accounts',
  },
]

export const activeUsersList = [
  {
    text: 'Active Users',
  },
  {
    text: '',
  },
  {
    text: '1 User',
  },
  {
    text: '3 Users',
  },
  {
    text: '4 to 6 Users',
  },
]

export const viewOnCompanyProfileList = [
  {
    text: 'View On Companies Profiles',
  },
  {
    text: 'Possibility to see the number of the companies available',
  },
  {
    text: '140 Prof./Week/User',
  },
  {
    text: '350 Prof./Week/User',
  },
  {
    text: '1400 Prof./Week/User',
  },
]

export const contactTelList = [
  {
    text: 'Contact Tel',
  },
  {
    text: '',
  },
  {
    text: 'Up to 140 Contacts for 1 user per week',
  },
  {
    text: 'Up To 350 Contacts for 1 user per week',
  },
  {
    text: 'Up To 1400 Contacts for 1 user per week',
  },
]

export const companyEmailContactEmailList = [
  {
    text: 'Company Email & Contact Email',
  },
  {
    text: '',
  },
  {
    text: '',
  },
  {
    text: 'Up To 350 Emails for 1 user per week',
  },
  {
    text: 'Up To 1400 Emails for 1 user per week',
  },
]

export const salesOfferPublicationList = [
  {
    text: 'Sales Offers Publication',
  },
  {
    text: '',
  },
  {
    text: '',
  },
  {
    text: '1 SO / year (product can be changed)',
  },
  {
    text: 'Unlimited',
  },
]

export const buyersAlertPublicationList = [
  {
    text: 'Buyers Alert Publication',
  },
  {
    text: '1 Ba- 1X/ 1Month',
  },
  {
    text: '3 Ba- 1X/ 1Month',
  },
  {
    text: '5 Ba 1X/ Month',
  },
  {
    text: 'Unlimited',
  },
]

export const timeToDeliverBaList = [
  {
    text: 'Time To Deliver Buyer Alert Publication',
  },
  {
    text: '',
  },
  {
    text: 'Within A Week',
  },
  {
    text: '<24H',
  },
  {
    text: '<24H',
  },
]

export const baForSupplierList = [
  {
    text: 'Buyers Alerts For A Supplier',
  },
  {
    text: 'SUPPRESS line',
  },
  {
    text: '',
  },
  {
    text: '',
  },
  {
    text: '',
  },
]

export const noOfProductsList = [
  {
    text: 'Number Of Products',
  },
  {
    text: '',
  },
  {
    text: 'Not Applicable',
  },
  {
    text: '5 Products',
  },
  {
    text: 'Unlimited',
  },
]

export const seeBuyerAlertList = [
  {
    text: 'See Buyer Alert',
  },
  {
    isImageCell: true,
  },
  {
    isImageCell: true,
  },
  {
    isImageCell: true,
  },
  {
    isImageCell: true,
  },
]

export const seeBaWithoutCompanyAndDetailsList = [
  {
    text: 'See Buyer Alert Without Company & Contact Details',
  },
  {
    text: '',
  },
  {
    text: '',
  },
  {
    isImageCell: true,
  },
  {
    isImageCell: true,
  },
]

export const sendMsgToBaList = [
  {
    text: 'Possibility to Send Message To Buyer Via App',
  },
  {
    text: 'SUPPRESS line',
  },
  {
    text: '',
  },
  {
    isImageCell: true,
  },
  {
    isImageCell: true,
  },
]

export const guarantyAlertList = [
  {
    text: 'Guaranty 50 Alerts For Minimum 3 Products',
  },
  {
    text: '',
  },
  {
    text: '',
  },
  {
    text: '',
  },
  {
    isImageCell: true,
  },
]

export const scoreAlertList = [
  {
    text: 'Score Alert',
  },
  {
    text: '',
  },
  {
    text: 'Yes On 5 Companies',
  },
  {
    text: 'Yes On 20 Companies',
  },
  {
    text: 'Unlimited',
  },
]

export const alertOnTagCompaniesList = [
  {
    text: 'Alert On Tagged Companies (News / Suspicious Blog / Update)',
  },
  {
    text: '',
  },
  {
    text: 'Yes On 5 Companies',
  },
  {
    text: 'Yes On 20 Companies',
  },
  {
    text: 'Unlimited',
  },
]

export const reputationScoreCardList = [
  {
    text: 'Visible Only On Gm Pm',
  },
  {
    text: 'Visible - 10/m',
  },
  {
    text: 'Visible - 200/m',
  },
  {
    text: 'Unlimited',
  },
]

export const searchOnBlogList = [
  {
    text: 'Search On Blog',
  },
  {
    text: '',
  },
  {
    text: '',
  },
  {
    isImageCell: true,
  },
  {
    isImageCell: true,
  },
]

export const cardScannerList = [
  {
    text: 'Cards Scanner',
  },
  {
    isImageCell: true,
  },
  {
    isImageCell: true,
  },
  {
    isImageCell: true,
  },
  {
    isImageCell: true,
  },
]

export const photoshopedDocList = [
  {
    text: 'Photoshoped Doc Check',
  },
  {
    isImageCell: true,
  },
  {
    text: '5/m',
  },
  {
    text: 'Unlimited',
  },
  {
    text: 'Unlimited',
  },
]

export const sendEmailProfileList = [
  {
    text: 'Send E Mail To Other Fructidor Profiles',
  },
  {
    text: '',
  },
  {
    text: '10 /day',
  },
  {
    text: '60 /day',
  },
  {
    text: '100 /day',
  },
]

export const introToGoldPlatinum = [
  {
    text: '',
  },
  {
    text: '',
  },
  {
    text: '',
  },
  {
    isImageCell: true,
  },
]

export const prioritySupportList = [
  {
    text: '',
  },
  {
    text: '',
  },
  {
    text: '',
  },
  {
    isImageCell: true,
  },
]

export const advertisingList = [
  {
    text: '',
  },
  {
    text: '',
  },
  {
    text: '',
  },
  {
    isImageCell: true,
    text: 'Banner on the website',
  },
]
